import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '@app/services/app.service';
import {
    KuiAlertComponent,
    KuiButtonComponent,
    KuiCardComponent,
    KuiDividerComponent,
} from '@kone/ui';
import { AuthHeaderComponent } from '@pages/auth/components/auth-header/auth-header.component';
import { translations } from '@utils/translations';

@Component({
    standalone: true,
    selector: 'app-no-user',
    templateUrl: './no-user.component.html',
    imports: [
        AuthHeaderComponent,
        KuiAlertComponent,
        KuiButtonComponent,
        KuiCardComponent,
        KuiDividerComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: `
        :host {
            @apply flex items-center justify-center h-dvh;

            ::ng-deep kui-alert .alert-balloon div {
                text-align: center;
            }
        }
    `,
})
export class NoUserComponent {
    protected readonly translations = translations;
    protected readonly appService = inject(AppService);
}
